import { trackNewsletterSignup } from './analytics';

declare global {
  interface Window {
    mcjsoncallback: (data: { result: string; msg: string }) => void;
  }
}

const MC_URL =
  'https://tooshortpants.us19.list-manage.com/subscribe/post-json' +
  '?u=0032b819d56f84b3acb86bcff&id=3652156c3d&f_id=0049a4e4f0';

export function initMailchimp(): void {
  const form = document.getElementById('mc-embedded-subscribe-form') as HTMLFormElement | null;
  const status = document.getElementById('mc-status');

  if (!form || !status) return;

  form.addEventListener('submit', (e: Event) => {
    e.preventDefault();
    const emailInput = document.getElementById('mce-EMAIL') as HTMLInputElement | null;
    if (!emailInput) return;

    status.textContent = '';
    status.className = 'text-sm';

    const url = `${MC_URL}&EMAIL=${encodeURIComponent(emailInput.value)}&c=mcjsoncallback`;

    window.mcjsoncallback = (data) => {
      if (data.result === 'success') {
        status.textContent = "You're on the list!";
        status.className = 'text-sm text-inverse-primary';
        trackNewsletterSignup();
        form.reset();
      } else {
        status.textContent = data.msg.replace(/^\d+ - /, '');
        status.className = 'text-sm text-error-container';
      }
      document.getElementById('mc-jsonp')?.remove();
    };

    document.getElementById('mc-jsonp')?.remove();
    const script = document.createElement('script');
    script.id = 'mc-jsonp';
    script.src = url;
    document.body.appendChild(script);
  });
}
